import React from 'react';

import {ErrorPage} from './components/error-page';

type Props = {mix?: string};

export const PageNotFound = (props: Props) => {
    return (
        <ErrorPage
            title="Sorry, the page you are looking for cannot be found"
            subtitle="Please try your search again"
            mix={props.mix}
        />
    );
};

export const InternalServerError = (props: Props) => (
    <ErrorPage
        title="Sorry, the page you're looking for is temporarily unavailable"
        subtitle="Our support team is working to resolve this. Try the links below or you can search again."
        mix={props.mix}
    />
);
